export default __webpack_public_path__ + "static/media/czechgo-screenshot-04.d88a2340.png";